import { atom, PrimitiveAtom } from 'jotai';

import { RestaurantLocationCoordinates } from '@restworld/data-services';

export type SelectedVenue = {
  id: string;
  name: string;
  coordinates: { lat: number; lon: number };
  address?: string;
};

// The venue selected by the prospect on the map
export const selectedVenueAtom = atom<SelectedVenue | null>(null) as PrimitiveAtom<SelectedVenue | null>;

// Controls the referral request modal flow visibility
export const showRequestModalAtom = atom(false);

// Controls the logged-in user modal visibility
export const showLoggedInModalAtom = atom(false);

// Map coordinates data fetched from API
export const venueCoordinatesAtom = atom<RestaurantLocationCoordinates[]>([]);

// Initial map view state (center + zoom), overridden by city-specific pages
export const initialMapViewStateAtom = atom<{ longitude: number; latitude: number; zoom: number }>({
  longitude: 12.4964,
  latitude: 41.9028,
  zoom: 5.5,
});
